export default __webpack_public_path__ + "static/media/jbc.37bbf35b.png";